module.exports = __webpack_public_path__ + "static/media/Logo_RTCplus.c1eafb96.svg";